// extracted by mini-css-extract-plugin
module.exports = {"sectionHeaderActions":"SectionHeaderActions_sectionHeaderActions__LhKhl"};